// Счётчик отмеченных продуктов на кнопке «Исключить».
//
// Считаем по DOM, а не прибавляем и вычитаем по событиям: галочки ставит
// и человек, и кнопка «Исключить все», и при подсчёте по событиям число
// на кнопке рано или поздно разъезжается с тем, что отмечено.
export function refreshExcludedCounter($) {
    const count = $('.exclude-product__input:checked').length;
    $('.checked-products-counter').html(count);
    return count;
}
